import { useI18n } from "i18n";
import { Typography } from "@remo-co/ui-core/src/components/Typography";
import { Button } from "@remo-co/ui-core/src/components/Button";
import { Box } from "@remo-co/ui-core/src/components/Box";
import EmailsSVG from "../../assets/emails.svg";
import { styles } from "./styles";

export const EmptyState = () => {
  const { t } = useI18n(["common", "eventForm", "url"]);

  return (
    <Box sx={styles.container}>
      <Box sx={styles.imageContainer}>
        <img src={EmailsSVG} alt={t("eventForm:customize.your.emails")} />
      </Box>
      <Typography variant="body1" sx={styles.text}>
        {t("eventForm:customize.emails.custom.branding.note")}
      </Typography>
      <Typography variant="body2" sx={styles.listTitle}>
        {t("eventForm:customize.emails.custom.branding.list.title")}
      </Typography>
      <Box component="ul" sx={styles.list}>
        <li>
          <Typography variant="body2">
            {t("eventForm:customize.emails.custom.branding.list.item.1")}
          </Typography>
        </li>
        <li>
          <Typography variant="body2">
            {t("eventForm:customize.emails.custom.branding.list.item.2")}
          </Typography>
        </li>
        <li>
          <Typography variant="body2">
            {t("eventForm:customize.emails.custom.branding.list.item.3")}
          </Typography>
        </li>
        <li>
          <Typography variant="body2">
            {t("eventForm:customize.emails.custom.branding.list.item.4")}
          </Typography>
        </li>
        <li>
          <Typography variant="body2">
            {t("eventForm:customize.emails.custom.branding.list.item.5")}
          </Typography>
        </li>
      </Box>
      <Box sx={styles.buttonContainer}>
        <Button<"a">
          variant="special"
          color="green"
          size="md"
          href={t("url:contact.support.mailto")}
          data-testid="contact-remo-team-button"
        >
          {t("eventForm:customize.emails.custom.branding.cta")}
        </Button>
      </Box>
    </Box>
  );
};
